/** Airdrop CSV columns: address, amount */
export type AirdropColumns = {
  /** Recipient wallet address (Solana base58) */
  address: string;
  /** Token amount to airdrop */
  amount: string;
};
